import { NgModule } from '@angular/core';
import { AmdWindowRef } from './window-ref.service';
var AmdWindowRefModule = /** @class */ (function () {
    function AmdWindowRefModule() {
    }
    AmdWindowRefModule.decorators = [
        { type: NgModule, args: [{
                    providers: [AmdWindowRef]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdWindowRefModule.ctorParameters = function () { return []; };
    return AmdWindowRefModule;
}());
export { AmdWindowRefModule };
function AmdWindowRefModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdWindowRefModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdWindowRefModule.ctorParameters;
}
//# sourceMappingURL=window-ref.module.js.map
//# sourceMappingURL=window-ref.module.js.map
